export default "__VITE_ASSET__CABvErgz__"